"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperiencePlatform = void 0;
const react_1 = __importStar(require("react"));
const react_uid_1 = require("react-uid");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const apiService_1 = __importDefault(require("../../../common/services/apiService"));
const SearchBar_1 = __importDefault(require("../ExperiencePlatform/SearchBar"));
const ExperiencePlatformWrapper = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1102;
  background: #fff;
  height: 100%;
  width: 100%;
  overflow: auto;
`;
const ProductsWrapper = styled_components_1.default.div `
  margin-top: 16px;
`;
const CategoriesAndProducts = styled_components_1.default.div `
  padding: 16px;

  button {
    color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.main : "#000"};
    border-color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.main : "#000"};

    &:hover {
      border-color: ${(props) => props.theme.palette ? props.theme.palette.mainAppColor.main : "#000"};
    }
  }
`;
const Chips = styled_components_1.default.div `
  .MuiChip-root {
    margin: 0 10px 10px 0;
  }
`;
const CardTitle = styled_components_1.default.div `
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 1rem;
  }
  font-weight: 500;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
const CardSubtitle = styled_components_1.default.div `
  font-size: 0.7rem;
  font-weight: 400;
  opacity: 0.6;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;
const CardDescription = styled_components_1.default.div `
  font-size: 0.875rem;
  font-weight: 400;
  opacity: 0.6;
  padding-top: 16px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  min-height: 80px;

  p {
    margin: 0px;
  }
`;
const ExperiencePlatform = (props) => {
    const { userData, locale, withSearchBar } = props;
    const [chips, setChips] = (0, react_1.useState)([]);
    const [products, setProducts] = (0, react_1.useState)([]);
    const [showLoader, setShowLoader] = (0, react_1.useState)(true);
    const [showChips, setShowChips] = (0, react_1.useState)(true);
    const [productsLoader, setProductsLoader] = (0, react_1.useState)(false);
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        const categories = yield apiService_1.default.getExperiencePlatformCategories(locale, userData.token);
        setChips(categories.map((category) => Object.assign(category, { selected: false })));
        setShowLoader(false);
    });
    (0, react_1.useEffect)(() => {
        initialSetup();
    }, []);
    (0, react_1.useEffect)(() => {
        setProductsLoader(true);
        const selectedChips = chips
            .filter((chip) => chip.selected)
            .map((chip) => chip.id)
            .join(",");
        apiService_1.default
            .getExperiencePlatformProducts(locale, userData.token, selectedChips)
            .then((data) => {
            setProducts(data);
            setProductsLoader(false);
        });
    }, [chips]);
    const goToProduct = (e, product) => {
        e.stopPropagation();
        window.open(product.url, "_blank");
    };
    const renderProducts = () => {
        if (!products.length) {
            return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, className: "center-align" }, i18n_js_1.default.t("no_results")));
        }
        return products.map((product) => (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, sm: 6, md: 4, key: (0, react_uid_1.uid)(product) },
            react_1.default.createElement(material_1.Card, { variant: "outlined" },
                react_1.default.createElement(material_1.CardMedia, { component: "img", image: product.imageUrl }),
                react_1.default.createElement(material_1.CardContent, null,
                    react_1.default.createElement(CardTitle, null, product.title),
                    react_1.default.createElement(CardSubtitle, null, product.subtitle),
                    react_1.default.createElement(CardDescription, { dangerouslySetInnerHTML: {
                            __html: product.description,
                        } })),
                react_1.default.createElement(material_1.CardActions, { sx: { justifyContent: "flex-end" } },
                    react_1.default.createElement(material_1.Button, { "data-testid": "product-button", variant: "outlined", onClick: (e) => goToProduct(e, product) }, product.buttonText))))));
    };
    const handleChipSelect = (chipId) => {
        setChips(chips.map((chip) => {
            if (chip.id === chipId) {
                return Object.assign(chip, { selected: !chip.selected });
            }
            return chip;
        }));
    };
    const resetChips = () => {
        setChips(chips.map((chip) => Object.assign(chip, { selected: false })));
    };
    const searchProducts = (searchTerm) => __awaiter(void 0, void 0, void 0, function* () {
        setProductsLoader(true);
        const updatedProducts = yield apiService_1.default.getExperiencePlatformProducts(locale, userData.token, [], searchTerm);
        setProducts(updatedProducts);
        setProductsLoader(false);
    });
    const onSearchInputFocus = () => {
        setProducts([]);
        resetChips();
        setShowChips(false);
    };
    const onSearchBarClose = () => {
        setShowChips(true);
        resetChips();
        searchProducts("");
    };
    const renderChips = () => chips.map((chip) => (react_1.default.createElement(material_1.Chip, { key: chip.id, id: chip.id, label: chip.name, "data-testid": "category", onClick: () => handleChipSelect(chip.id) })));
    return (react_1.default.createElement(ExperiencePlatformWrapper, null,
        withSearchBar && (react_1.default.createElement(SearchBar_1.default, { searchProducts: searchProducts, onInputFocus: onSearchInputFocus, onClose: onSearchBarClose })),
        react_1.default.createElement(material_1.Toolbar, null),
        showLoader ? (react_1.default.createElement(Loader_1.default, null)) : (react_1.default.createElement(CategoriesAndProducts, { "data-testid": "categories-and-products" },
            showChips && react_1.default.createElement(Chips, null, renderChips()),
            productsLoader ? (react_1.default.createElement(Loader_1.default, null)) : (react_1.default.createElement(ProductsWrapper, { "data-testid": "products" },
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, renderProducts())))))));
};
exports.ExperiencePlatform = ExperiencePlatform;
const mapStoreToProps = (store) => ({
    userData: store.getValue("userData"),
    locale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.ExperiencePlatform);
